import axios from 'axios';
import {
    COMMERCIAL_FILE_UPLOAD_FAIL,
    COMMERCIAL_FILE_UPLOAD_REQUEST,
    COMMERCIAL_FILE_UPLOAD_SUCCESS,
    COMMERCIALS_LIST_FAIL,
    COMMERCIALS_LIST_REQUEST,
    COMMERCIALS_LIST_SUCCESS,
    COMMERCIAL_DETAIL_REQUEST,
    COMMERCIAL_DETAIL_SUCCESS,
    COMMERCIAL_DETAIL_FAIL,
    COMMERCIAL_DELETE_REQUEST,
    COMMERCIAL_DELETE_SUCCESS,
    COMMERCIAL_DELETE_FAIL,
    COMMERCIAL_UPDATE_REQUEST,
    COMMERCIAL_UPDATE_SUCCESS,
    COMMERCIAL_UPDATE_FAIL,
} from '../constants/commercialConstants';

import {
    SIGNAL_FILE_UPLOAD_FAIL,
    SIGNAL_FILE_UPLOAD_REQUEST,
    SIGNAL_FILE_UPLOAD_SUCCESS,
    SIGNAL_DELETE_FAIL,
    SIGNAL_DELETE_REQUEST,
    SIGNAL_DELETE_SUCCESS,
    SIGNAL_DETAILS_FAIL,
    SIGNAL_DETAILS_REQUEST,
    SIGNAL_DETAILS_SUCCESS,
    SIGNAL_LIST_REQUEST,
    SIGNAL_LIST_SUCCESS,
    SIGNAL_UPDATE_DETAILS_FAIL,
    SIGNAL_UPDATE_DETAILS_REQUEST,
    SIGNAL_UPDATE_DETAILS_SUCCESS,
} from '../constants/signalConstants';

import {
    ANNOUNCEMENT_LIST_REQUEST,
    ANNOUNCEMENT_LIST_SUCCESS,
    ANNOUNCEMENT_LIST_FAIL,
    ANNOUNCEMENT_FILE_UPLOAD_REQUEST,
    ANNOUNCEMENT_FILE_UPLOAD_SUCCESS,
    ANNOUNCEMENT_FILE_UPLOAD_FAIL,
    ANNOUNCEMENT_DETAIL_FAIL,
    ANNOUNCEMENT_DETAIL_REQUEST,
    ANNOUNCEMENT_DETAIL_SUCCESS,
    ANNOUNCEMENT_UPDATE_REQUEST,
    ANNOUNCEMENT_UPDATE_SUCCESS,
    ANNOUNCEMENT_UPDATE_FAIL,
    ANNOUNCEMENT_DELETE_REQUEST,
    ANNOUNCEMENT_DELETE_SUCCESS,
    ANNOUNCEMENT_DELETE_FAIL,
} from '../constants/announcementConstants';
import {
    VIDEO_DELETE_FAIL,
    VIDEO_DELETE_REQUEST, VIDEO_DELETE_SUCCESS,
    VIDEO_DETAILS_FAIL,
    VIDEO_DETAILS_REQUEST, VIDEO_DETAILS_SUCCESS,
    VIDEO_FILE_UPLOAD_FAIL,
    VIDEO_FILE_UPLOAD_REQUEST, VIDEO_FILE_UPLOAD_SUCCESS,
    VIDEO_LIST_FAIL,
    VIDEO_LIST_REQUEST,
    VIDEO_LIST_SUCCESS, VIDEO_UPDATE_DETAILS_FAIL, VIDEO_UPDATE_DETAILS_REQUEST, VIDEO_UPDATE_DETAILS_SUCCESS
} from "../constants/videoConstants";

export const listMedia = (media) => async (dispatch, getState) => {
    let listRequest;
    let listSuccess;
    let listFail;
    switch (media) {
        case 'commercials':
            listRequest = COMMERCIALS_LIST_REQUEST;
            listSuccess = COMMERCIALS_LIST_SUCCESS;
            listFail = COMMERCIALS_LIST_FAIL;
            break;
        case 'signals':
            listRequest = SIGNAL_LIST_REQUEST;
            listSuccess = SIGNAL_LIST_SUCCESS;
            listFail = SIGNAL_DETAILS_FAIL;
            break;
        case 'announcements':
            listRequest = ANNOUNCEMENT_LIST_REQUEST;
            listSuccess = ANNOUNCEMENT_LIST_SUCCESS;
            listFail = ANNOUNCEMENT_LIST_FAIL;
            break;
        case 'videos':
            listRequest = VIDEO_LIST_REQUEST;
            listSuccess = VIDEO_LIST_SUCCESS;
            listFail = VIDEO_LIST_FAIL;
            break;
        default:
            listRequest = COMMERCIALS_LIST_REQUEST;
            listSuccess = COMMERCIALS_LIST_SUCCESS;
            listFail = COMMERCIALS_LIST_FAIL;
            break;
    }
    try {
        dispatch({ type: listRequest });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        const { data } = await axios.get(`/api/${media}`, config);

        dispatch({ type: listSuccess, payload: data });
    } catch (error) {
        dispatch({
            type: listFail,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const uploadMedia = (media, formData) => async (dispatch, getState) => {
    let uploadRequest;
    let uploadSuccess;
    let uploadFail;
    switch (media) {
        case 'commercials':
            uploadRequest = COMMERCIAL_FILE_UPLOAD_REQUEST;
            uploadSuccess = COMMERCIAL_FILE_UPLOAD_SUCCESS;
            uploadFail = COMMERCIAL_FILE_UPLOAD_FAIL;
            break;
        case 'signals':
            uploadRequest = SIGNAL_FILE_UPLOAD_REQUEST;
            uploadSuccess = SIGNAL_FILE_UPLOAD_SUCCESS;
            uploadFail = SIGNAL_FILE_UPLOAD_FAIL;
            break;
        case 'announcements':
            uploadRequest = ANNOUNCEMENT_FILE_UPLOAD_REQUEST;
            uploadSuccess = ANNOUNCEMENT_FILE_UPLOAD_SUCCESS;
            uploadFail = ANNOUNCEMENT_FILE_UPLOAD_FAIL;
            break;
        case 'videos':
            uploadRequest = VIDEO_FILE_UPLOAD_REQUEST;
            uploadSuccess = VIDEO_FILE_UPLOAD_SUCCESS;
            uploadFail = VIDEO_FILE_UPLOAD_FAIL;
            break;
    }
    try {
        dispatch({ type: uploadRequest });
        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${userInfo.token}`,
            },
            timeout: 60000,
        };

        const { data } = await axios.post(
            `/api/${media}/upload`,
            formData,
            config
        );
        dispatch({ type: uploadSuccess, payload: data });
    } catch (error) {
        dispatch({
            type: uploadFail,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const listMediaDetails = (media, id) => async (dispatch, getState) => {
    let detailRequest;
    let detailSuccess;
    let detailFail;
    switch (media) {
        case 'commercials':
            detailRequest = COMMERCIAL_DETAIL_REQUEST;
            detailSuccess = COMMERCIAL_DETAIL_SUCCESS;
            detailFail = COMMERCIAL_DETAIL_FAIL;
            break;
        case 'signals':
            detailRequest = SIGNAL_DETAILS_REQUEST;
            detailSuccess = SIGNAL_DETAILS_SUCCESS;
            detailFail = SIGNAL_DETAILS_FAIL;
            break;
        case 'announcements':
            detailRequest = ANNOUNCEMENT_DETAIL_REQUEST;
            detailSuccess = ANNOUNCEMENT_DETAIL_SUCCESS;
            detailFail = ANNOUNCEMENT_DETAIL_FAIL;
            break;
        case 'videos':
            detailRequest = VIDEO_DETAILS_REQUEST;
            detailSuccess = VIDEO_DETAILS_SUCCESS;
            detailFail = VIDEO_DETAILS_FAIL;
            break;
        default:
            detailRequest = COMMERCIAL_DETAIL_REQUEST;
            detailSuccess = COMMERCIAL_DETAIL_SUCCESS;
            detailFail = COMMERCIAL_DETAIL_FAIL;
            break;
    }
    try {
        dispatch({ type: detailRequest });
        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
            timeout: 10000,
        };
        const { data } = await axios.get(`/api/${media}/${id}`, config);
        dispatch({ type: detailSuccess, payload: data });
    } catch (error) {
        dispatch({
            type: detailFail,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const updateMedia = ({ media, id, formData }) => async (
    dispatch,
    getState
) => {
    let updateRequest;
    let updateSuccess;
    let updateFail;
    switch (media) {
        case 'commercials':
            updateRequest = COMMERCIAL_UPDATE_REQUEST;
            updateSuccess = COMMERCIAL_UPDATE_SUCCESS;
            updateFail = COMMERCIAL_UPDATE_FAIL;
            break;
        case 'signals':
            updateRequest = SIGNAL_UPDATE_DETAILS_REQUEST;
            updateSuccess = SIGNAL_UPDATE_DETAILS_SUCCESS;
            updateFail = SIGNAL_UPDATE_DETAILS_FAIL;
            break;
        case 'announcements':
            updateRequest = ANNOUNCEMENT_UPDATE_REQUEST;
            updateSuccess = ANNOUNCEMENT_UPDATE_SUCCESS;
            updateFail = ANNOUNCEMENT_UPDATE_FAIL;
            break;
        case 'videos':
            updateRequest = VIDEO_UPDATE_DETAILS_REQUEST;
            updateSuccess = VIDEO_UPDATE_DETAILS_SUCCESS;
            updateFail = VIDEO_UPDATE_DETAILS_FAIL;
            break;
        default:
            updateRequest = COMMERCIAL_UPDATE_REQUEST;
            updateSuccess = COMMERCIAL_UPDATE_SUCCESS;
            updateFail = COMMERCIAL_UPDATE_FAIL;
            break;
    }
    try {
        dispatch({ type: updateRequest });
        const {
            userLogin: { userInfo },
        } = getState();
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${userInfo.token}`,
            },
            timeout: 90000,
        };
        const { data } = await axios.put(
            `/api/${media}/${id}`,
            formData,
            config
        );
        //console.log(data);
        dispatch({ type: updateSuccess, payload: data });
    } catch (error) {
        dispatch({
            type: updateFail,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteMedia = (media, id) => async (dispatch, getState) => {
    let deleteRequest;
    let deleteSuccess;
    let deleteFail;
    switch (media) {
        case 'commercials':
            deleteRequest = COMMERCIAL_DELETE_REQUEST;
            deleteSuccess = COMMERCIAL_DELETE_SUCCESS;
            deleteFail = COMMERCIAL_DELETE_FAIL;
            break;
        case 'signals':
            deleteRequest = SIGNAL_DELETE_REQUEST;
            deleteSuccess = SIGNAL_DELETE_SUCCESS;
            deleteFail = SIGNAL_DELETE_FAIL;
            break;
        case 'announcements':
            deleteRequest = ANNOUNCEMENT_DELETE_REQUEST;
            deleteSuccess = ANNOUNCEMENT_DELETE_SUCCESS;
            deleteFail = ANNOUNCEMENT_DELETE_FAIL;
            break;
        case 'videos':
            deleteRequest = VIDEO_DELETE_REQUEST;
            deleteSuccess = VIDEO_DELETE_SUCCESS;
            deleteFail = VIDEO_DELETE_FAIL;
            break;
        default:
            deleteRequest = COMMERCIAL_DELETE_REQUEST;
            deleteSuccess = COMMERCIAL_DELETE_SUCCESS;
            deleteFail = COMMERCIAL_DELETE_FAIL;
            break;
    }
    try {
        dispatch({ type: deleteRequest });
        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
            timeout: 10000,
        };
        const { data } = await axios.delete(`/api/${media}/${id}`, config);
        dispatch({ type: deleteSuccess, payload: data });
    } catch (error) {
        dispatch({
            type: deleteFail,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};
